import { handleActions } from 'redux-actions';

export default handleActions({
	RECEIVE_DATA: (state, action) => {
		var artists = {};
		action.payload.forEach(item => {
			if (item.value.type == 'artist') {
				artists[item.value.id] = item.value;
			}
		});
		return Object.assign({}, state, artists);
	}
}, {});


// WEBPACK FOOTER //
// ./src/client/reducers/artistsReducer.js